import { getAllocationTypeOptions } from "src/apis/lever";

class LeverService {
    constructor() {
        this.options = [];
    }

    getOptions = async () => {
        if (this.options.length > 0) return this.options;

        const response = await getAllocationTypeOptions()
        
        this.options = response.data.message;
        return this.options
    };
}

const service = new LeverService();
export default service